const CHANGE_LIST_TITLE = 'CHANGE_LIST_TITLE';
const ADD_LIST = 'ADD_LIST';
const REMOVE_LIST = 'REMOVE_LIST';
const ADD_TODO_TO_LIST = 'ADD_TODO_TO_LIST';
const CHANGE_TODO_TITLE = 'CHANGE_TODO_TITLE';
const REMOVE_TODO = 'REMOVE_TODO';
const CHANGE_COMPLETED_TODO = 'CHANGE_COMPLETED_TODO';
const CHANGE_IMPORTANT_TODO = 'CHANGE_IMPORTANT_TODO';
const CHANGE_DEADLINE_DATE_TODO = 'CHANGE_DEADLINE_DATE_TODO';
const CHANGE_NOTE_TODO = 'CHANGE_NOTE_TODO';

export {
	CHANGE_LIST_TITLE,
	ADD_LIST,
	REMOVE_LIST,
	ADD_TODO_TO_LIST,
	CHANGE_TODO_TITLE,
	REMOVE_TODO,
	CHANGE_COMPLETED_TODO,
	CHANGE_IMPORTANT_TODO,
	CHANGE_DEADLINE_DATE_TODO,
	CHANGE_NOTE_TODO
}